import { UserSubscriptionDetails } from '@anm/api/modules/user';

const getCurrentSubscription = (
  subscriptionDetails: UserSubscriptionDetails[],
  product = 'WAVE'
) => subscriptionDetails.find(sub => sub.product === product)!;

export default getCurrentSubscription;
